// extracted by mini-css-extract-plugin
module.exports = {"text-warning":"text-warning__3lRc6","loading":"loading__zu-uk","icon":"icon__8grpk","button-loader":"button-loader__3d7uG"};